import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";

const REASONS = ["تم حل المشكلة ولم أعد بحاجة للسطحة", "وجدت سطحة أخرى", "العروض متأخرة", "الأسعار مرتفعة", "أخرى"];

export const CancelTowDialog = ({ towId, onDone }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [other, setOther] = useState("");
  const [busy, setBusy] = useState(false);
  const isOther = reason === "أخرى";

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/tow-requests/${towId}/cancel`, { reason: isOther ? `أخرى: ${other.trim()}` : reason });
      toast.success("تم إلغاء طلب السطحة");
      setOpen(false);
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="w-full rounded-xl gap-2 text-destructive border-destructive/40 hover:bg-destructive/10" data-testid="cancel-tow-btn">
          <XCircle className="w-4 h-4" /> إلغاء طلب السطحة
        </Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="cancel-tow-dialog">
        <DialogHeader><DialogTitle>لماذا تريد إلغاء الطلب؟</DialogTitle></DialogHeader>
        <RadioGroup value={reason} onValueChange={setReason} dir="rtl" className="space-y-2">
          {REASONS.map((r, i) => (
            <div key={r} className="flex items-center gap-2">
              <RadioGroupItem value={r} id={`cr-${i}`} data-testid={`cancel-reason-${i}`} />
              <Label htmlFor={`cr-${i}`} className="cursor-pointer">{r}</Label>
            </div>
          ))}
        </RadioGroup>
        {isOther && <Textarea value={other} onChange={(e) => setOther(e.target.value)} placeholder="اكتب السبب" maxLength={300} data-testid="cancel-reason-other" />}
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => setOpen(false)} data-testid="cancel-tow-back">تراجع</Button>
          <Button onClick={submit} disabled={busy || !reason || (isOther && !other.trim())} className="bg-destructive hover:bg-destructive/90 gap-2" data-testid="cancel-tow-confirm">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} تأكيد الإلغاء
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
